// src/pages/EventoDetalle.jsx
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { eventos } from "../data/eventos";
import { FaCalendarAlt, FaClock, FaMapMarkerAlt } from "react-icons/fa";

const EventoDetalle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const evento = eventos.find(e => e.slug === slug);
  if (!evento) return <p>Evento no encontrado</p>;

  return (
    <section className="section">
      <div className="container">
        <button onClick={() => navigate(-1)} className="form-button" style={{ marginBottom: "1.5rem" }}>
          ← Volver
        </button>

        <img src={evento.imagen} alt={evento.titulo} className="section-image" />
        <h2 className="section-title">{evento.titulo}</h2>
        <p className="contact-heading">{evento.descripcionCorta}</p>

        {evento.imagenesExtra?.length > 0 && (
        <div className="evento-galeria">
          {evento.imagenesExtra.map((src, i) => (
            <img key={i} src={src} alt={`Imagen extra ${i}`} className="evento-img" />
          ))}
        </div>
        )}

        <div className="taller-detalle-texto">
          {evento.descripcionLarga.split(/\n\s*\n/).map((parrafo, i) => (
          <p key={i}>{parrafo}</p>
        ))}
        </div>

        <div className="taller-detalle-ficha">
          <div><strong><FaCalendarAlt /></strong> {evento.fecha}</div>
          <div><strong><FaClock /></strong> {evento.hora}</div>
          <div><strong><FaMapMarkerAlt /></strong> {evento.lugar}</div>
        </div>

        {evento.link && (
          <a href={evento.url} target="_blank" rel="noopener noreferrer" className="form-button red-button">
            {evento.link}
          </a>
        )}
      </div>
    </section>
  );
};

export default EventoDetalle;
